import MuiTextareaAutosize, {
  TextareaAutosizeProps as Props
} from '@material-ui/core/TextareaAutosize'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

export type TextareaAutosizeProps = Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: `1px solid ${theme.palette.grey[600]}`,
      borderRadius: 4,
      boxSizing: 'border-box',
      padding: theme.spacing(1.5),
      ...theme.typography.body2
    }
  })
)

export const TextareaAutosize: React.FC<TextareaAutosizeProps> = (props) => {
  const classes = useStyles()

  return <MuiTextareaAutosize className={classes.root} {...props} />
}

export default TextareaAutosize